<template>
    <div class="home">
      <!-- 已登录导航 -->
      <header class="home-top" >
        <div class="header header--home">
          <div class="header__logo">
            <img src="https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/yueqiaoLogo.png"/>
            <div>
              <span>广州粤桥工程咨询有限公司</span>
              <span>GUANGZHOU YUEQIAO ENGINEERING CONSULTING Co., LTD</span>
            </div>
          </div>
          <div class="header__nav">
            <div
              v-for="item in navList"
              :key="item.key"
              :class="selectedNav === item.key ? 'items selected' : 'items'"
            >
              <span @click="handleLinkTo(item.key)">
                {{ item.title }}
              </span>
            </div>
          </div>
        </div>
      </header>
      <!-- 未登录导航 -->
      <!-- <header
        v-else
        class="header header--other"
      >
          <div class="header__logo">
            <img src="https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/yueqiaoLogo.png" />
            <div>
              <span>广州粤桥工程咨询有限公司</span>
              <span>GUANGZHOU YUEQIAO ENGINEERING CONSULTING Co., LTD</span>
            </div>
          </div>
        <div class="header__nav">
          <div
            v-for="item in navList"
            :key="item.key"
            :class="selectedNav === item.key ? 'items selected' : 'items'"
          >
            <span @click="handleLinkTo(item.key)">
              {{ item.title }}
            </span>
          </div>
        </div>
      </header> -->
      <router-view
        class="content"
        @changeProduce="handleLinkTo"
        @changeLogin="handleLogin"
      />
      <!-- 页脚 -->
      <footer class="footer">
        <div class="footer__nav">
          <div>
            <div class="title">业务介绍</div>
            <div
              class="items"
              @click="handleSelectedProduce('struct_analyse')"
            >工程结构仿真</div>
            <div
              class="items"
              @click="handleSelectedProduce('struct_moni')"
            >工程智能监测</div>
            <div
              class="items"
              @click="handleSelectedProduce('struct_tech')"
            >工程数字科技</div>
            <!-- <div
              class="items"
              @click="handleSelectedProduce('struct_dev')"
            >工程科技研发</div> -->
          </div>
          <div>
            <div class="title">项目展示</div>
            <div
              class="items"
              @click="handleLinkTo('projectList')"
            >查看项目</div>
          </div>
          <div class="image-box">
            <div class="image">
              <img
                src="https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/qrcode_for_gh.jpg"
                width="100%"
                height="100%"
              />
            </div>
            <div class="title">关注粤桥工科微信公众号了解更多</div>
          </div>
          <div>
            <div class="title">友情链接</div>
            <div
              class="items"
              @click="openUrl('https://www.csijri.com/index.html')"
            >中新国际联合研究院</div>
            <div
              class="items"
              @click="openUrl('https://yueq.com.cn/bbs')"
            >校友圈</div>
          </div>
          <div>
            <div class="title">关于我们</div>
            <div
              class="items"
              @click="footLinkTo('about_us', 'introduce')"
            >公司简介</div>
            <div
              class="items"
              @click="footLinkTo('about_us', 'progress')"
            >发展历程</div>
            <!-- <div
              class="items"
              @click="handleLinkTo('about_us', 'productView')"
            >我们的产品观</div> -->
            <div
              class="items"
              @click="footLinkTo('about_us', 'contact')"
            >联系我们</div>
            <div
              class="items"
              @click="openUrl('https://cloud.yueq.com.cn/home')"
            >工程监测</div>
          </div>
        </div>
        <div class="footer__des">
          <pre>公司总部：广州市天河区长福路207号首层s26单元  研发中心：广州市黄埔区中新智慧一街7号a-1栋1008单元  </pre>
          <!-- 联系电话：020 - xxxxxxxx -->
          <pre>
            <span>Copyright © 2020 广州粤桥工程咨询有限公司 版权所有</span>
            <!-- <div style="width:300px;margin:0 auto; padding:20px 0;">
              <a target="_blank" href=" " style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
                <img src="" style="float:left;"/>
                <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">粤公网安备 44010602007527号</p >
                </a>
            </div> -->
          </pre>
          <pre>
            <span class="beian" @click="openUrl('https://beian.miit.gov.cn')">粤ICP备19155098号-2</span>
            <img src="https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/beian_icon.png" alt style="display:inline-block;width: 20px;height: 20px;" />
            <span class="beian" @click="openUrl('https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010602011654')">粤公网安备44010602011654号</span>
            <!-- <div style="width:300px;margin:0 auto; padding:20px 0;">
              <a target="_blank" href=" " style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
                <img src="https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/beian_icon.png" style="float:left;"/>
                <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">粤公网安备 44010602011654号</p>
              </a>
            </div> -->
          </pre>
        </div>
      </footer>
    </div>
  </template>
  
  <script>
  import { setToken, getToken, setUserInfo, removeToken, removeUserInfo } from '../../common/user'
  export default {
    name: 'Home',
    data () {
      return {
        headImg: '',
        selectedNav: '',
        navList: [
          { key: 'events', title: '同门会' },
          { key: 'bbs', title: '通讯录' },
        ],
        userFuncList: [ 'forget_password', 'modify_password' ],
        isLogin: false,
        signOutModal: false,
        hasnews: true,
        newsimage: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/news1Image.png',
        portHeight: '100vh'
      }
    },
    computed: {
      isMobile(){
        if(window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)){
          return true
        }
        else{
          return false
        }
      }
    },
    created () {
      if(getToken()){
        this.isLogin = true
      }
    },
    mounted() {
      if(this.isLogin){
        if(this.navList.includes(item=>item.key=='sign')) this.navList.pop()
        this.navList.push({ key: 'user_information', title: '用户中心' })
      }
      else{
        if(this.navList.includes(item=>item.key=='user_information')) this.navList.pop()
        this.navList.push({ key: 'sign', title: '登录|注册' })
      }
      if(this.isMobile){
        // document.write('<meta name="viewport" content="width=device-width, initial-scale=1.0,minimum-scale=1.0, maximum-scale=1.0,user-scalable=yes,shrink-to-fit=no">')
        this.portHeight = '80vh'
      }
      else{
        this.portHeight = '100vh'
      }
    },
    methods: {
      // 切换菜单
      handleLinkTo (name, tab) {
        if (name === 'toPlatform') {
          this.openUrl('https://cloud.yueq.com.cn/home')
          return 0
        }
        // if (parseInt(this.userFuncList.indexOf(name)) === -1) {
        //     this.selectedNav = name
        // } else {
        //     this.selectedNav = 'user_information'
        // }
        console.log(name)
        this.selectedNav = name
        if (tab) {
          this.$router.push({
            name: `${name}`,
            params: {
              scroll: tab
            }
          })
        } else {
          this.$router.push({
            name: `${name}`
          })
        }
      },
      // 底部跳转
      footLinkTo (name, type) {
        this.isHome = name === 'main_home'
        this.selectedNav = name
        if (type) {
          this.$router.push({
            name: `${name}`,
            query: {
              type: type
            }
          })
        } else {
          this.$router.push({
            name: `${name}`
          })
        }
      },
      // 外部链接
      openUrl (url) {
        window.open(url, '_blank')
      },
      handleSelected (name) {
        switch (name) {
          case 'userInfo':
            this.handleLinkTo('user_information')
            break
          case 'changePwd':
            this.handleLinkTo('modify_password')
            break
          case 'logOut':
            this.signOutModal = true
            break
        }
      },
      setPortHeight() {
        if(this.isMobile) {
          this.portHeight = '80vh'
        }
        else{
          this.portHeight = '100vh'
        }
      },
      handleLogin(status){
        if(status){
          this.isLogin = true
          if(this.navList.includes(item=>item.key=='sign')) this.navList.pop()
          this.navList.push({ key: 'user_information', title: '用户中心' })
          this.$forceUpdate()
          this.handleLinkTo('bbs')
          // window.location.reload()
        }
        else{
          //退出登录了
          this.isLogin = false
          window.localStorage.setItem('isLogin', false)
          removeToken()
          removeUserInfo()
          if(this.navList.includes(item=>item.key=='user_information')) this.navList.pop()
          this.navList.push({ key: 'sign', title: '登录|注册' })
          this.$forceUpdate()
          this.handleLinkTo('sign')
          window.location.reload()
        }
      }
    }
  }
  </script>
  <style lang="less" scoped>
  .home {
    min-height: 100%;
    // width: 100%;
    min-width: 1600px;
    position: relative;
    // display: flex;
    // flex-direction: column;
    .home-top {
    }
    .header--home {
      background-color: #212124;
      position: absolute;
      top: 0;
      left: 0;
    }
    .header {
      // position: fixed;
      z-index: 99;
      width: calc(100% - 0px);
      // min-width: 1300px;
      height: 128px;
      color: #fff;
      // padding: 0 56px;
      display: flex;
      justify-content: space-between;
      &__logo {
        display: flex;
        align-items: center;
        position: relative;
        // height: 56px;
        img{
          // width: 40%;
          width: 180px;
        }
        div {
          margin-left: -40px;
          span:first-of-type {
            display: block;
            width: 100%;
            text-align: center;
            font-size: 20px;
            line-height: 1.5em;
            letter-spacing: 10px;
            white-space: nowrap;
            padding-left: 8px;
          }
          span:last-of-type{
            display: block;
            width: 100%;
            text-align: center;
            font-size: 12px;
            white-space: nowrap;
          }
        }
      }
      &__nav {
        display: flex;
        justify-content: space-between;
        font-size: 18px;
        line-height: 1.5em;
        font-weight: 400;
        color: #818181;
        margin-top: 45px;
        // text-shadow: 5px 5px 5px #212124;
        .items {
          cursor: pointer;
          padding: 0 16px;
          margin: 0 5px;
        }
        .items:hover{
          color: #FFF;
        }
        /deep/.ivu-icon {
          font-size: 28px;
          line-height: 1em;
          // vertical-align: -1em;
        }
        .selected {
          color: #fff;
        }
        a {
          color: #818181;
        }
        .headImg {
          width: 28px;
          height: 28px;
          border-radius: 50%;
          margin-left: 8px;
        }
      }
    }
    .header--other {
      background-color: #212124;
    }
    .content {
      flex: 1;
      padding-top: 128px;
    }
    .footer {
      display: flex;
      flex-direction: column;
      align-items: center;
      color: #fff;
      background-color: #2e2e30;
      &__nav {
        width: 70%;
        padding: 48px;
        display: flex;
        justify-content: space-evenly;
        .title {
          margin-bottom: 16px;
          font-size: 16px;
          line-height: 1.5em;
          font-weight: bold;
        }
        .items {
          font-size: 12px;
          line-height: 2.5em;
          cursor: pointer;
        }
        .image-box {
          display: flex;
          flex-direction: column;
          align-items: center;
          .image {
            width: 144px;
            height: 144px;
            padding: 10px;
            background-color: #fff;
            border-radius: 32px;
            margin-bottom: 16px;
          }
        }
      }
      &__des {
        width: 100%;
        height: 88px;
        background-color: #212124;
        padding-top: 8px;
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 14px;
        line-height: 1.5em;
        pre {
          margin: 0;
          display: flex;
          justify-content: center;
          flex-direction: row;
        }
      }
    }
  }
  .beian{
    cursor: pointer;
    margin: 0 10px;
  }
  .beian:hover{
    text-decoration: underline;
    color: blue;
  }
  </style>
  